import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AccountUserService } from '../service/account.service';
import { CategoryGroupIds, TypeGroupIds } from '../modules/shared/constants/category-groupid.constants';
import { HttpService } from '../modules/shared/services/http.service';
import { Template } from './system/template/models/template';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ConfigurationService {

    private userAddedSubject = new Subject<void>();
    userSaved$ = this.userAddedSubject.asObservable();

    appUrl = "";
    apiUrl = "";
    apiUrlLead = '';
    apiUrlAccount = ''
    accountApiUrl = ''
    localAppUrl = "";
    appCore = "";
    configUrl = "";
    contactURL = "";
    questionnaireURL = "";
    apiUrlLogin = "";
    appOrgUrl = "";
    user: any;
    opportunityURL = "";
    baseUrl = "";
    territoryurl = "";
    vendorUrl = "";
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient, private accountUserService: AccountUserService, private httpService: HttpService,) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.appUrl = environment.apiUrl + "Lead/";
        this.apiUrl = environment.apiUrl;
        this.apiUrlLead = environment.apiUrlLead + 'API/';
        this.apiUrlAccount = environment.apiUrlAccount;
        this.accountApiUrl = environment.apiUrlAccount + "Account/";
        this.contactURL = environment.contactURL;
        this.localAppUrl = environment.localApiUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.baseUrl = environment.baseUrl;
        this.configUrl = environment.configUrl;
        this.questionnaireURL = environment.baseUrl + "LionO360ApplicationQuestionnaireAPI/LionO360/2.0/API/";
        this.apiUrlLogin = environment.apiUrlLogin;
        this.opportunityURL = environment.opportunityUrl;

        this.appOrgUrl = environment.appOrgUrl;
        this.territoryurl = environment.territoryURL;
        this.vendorUrl = environment.vendorUrl;
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    getAllConfiguration() {
        return this.http.get<any>(this.configUrl + "Configuration")
    }

    getConfigurationsByModuleName(configName) {
        return this.http.get<any>(`${this.configUrl}Configuration/ConfigurationsByModuleName?name=${configName}`)
    }

    getCaseConfigurations(configName) {
        return this.http.get<any>(`${this.configUrl}Configuration/ConfigurationsByModuleName?name=${configName}`)
    }
    getCaseConfigurationsByModuleName(objName) {
        return this.http.get<any>(`${this.configUrl}Configuration/ConfigurationsByModuleName?name=` + objName)
    }

    getCaseConfigurationsByNameTimeout(objName) {
        return this.http.get<any>(`${this.configUrl}Configuration/Name?name=` + objName)
            .toPromise()
            .then(res => res);
    }

    getDepartments() {
        return this.http.get<any>(this.appOrgUrl + "Department")
    }

    getModules() {
        return this.http.get<any>(this.configUrl + "LionO360_ObjectDisplay?typeId=71")
    }

    getAllModules() {
        return this.http.get<any>(this.configUrl + "LionO360_Object")
    }

    getConfigurationById(id) {
        return this.http.get<any>(this.configUrl + "Configuration/" + id)
            .toPromise()
            .then(res => res);
    }

    addConfiguration(obj) {
        return this.http.post<any>(this.configUrl + "Configuration", obj)
            .toPromise()
            .then(res => res);
    }

    updateConfiguration(obj) {
        if (obj.id == 0) {
            return this.http.post<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        } else {
            return this.http.put<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        }
    }
    getLeadCountry() {
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByLead')
            .toPromise()
            .then(res => res);
    }

    getAccountCountry(templateID) {
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByAccount?typeId=' + templateID)
            .toPromise()
            .then(res => res);
    }
    editConfiguration(obj) {
        return this.http.put<any>(this.configUrl + "Configuration/Edit", obj)
    }



    getAllCustomFields(id) {
        return this.http.get<any>(this.configUrl + 'Configuration/CustomAttributes?objectId=' + id)
            .toPromise()
            .then(res => res);
    }

    getCustomFieldById(id) {
        return this.http.get<any>(this.configUrl + 'Configuration/' + id)
            .toPromise()
            .then(res => res);
    }
    updateCustomFieldsConfiguration(obj) {
        return this.http.put<any>(this.configUrl + "Configuration/CustomAttribute", obj)
            .toPromise()
            .then(res => res);
    }
    addCustomFieldsConfiguration(obj) {
        return this.http.post<any>(this.configUrl + "Configuration/CustomAttribute", obj)
            .toPromise()
            .then(res => res);
    }
    deletCustomField(id) {
        return this.http.delete<any>(this.configUrl + "Configuration/CustomAttribute/" + id)
            .toPromise()
            .then(res => res);
    }
    getConfigurationEmail() {
        return this.http.get<any>(this.localAppUrl + 'configurationEmail')
            .toPromise()
            .then(res => res);
    }
    getConfigurationPhone() {
        return this.http.get<any>(this.localAppUrl + 'configurationPhone')
            .toPromise()
            .then(res => res);
    }
    getConfigurationSocial() {
        return this.http.get<any>(this.localAppUrl + 'configurationSocial')
            .toPromise()
            .then(res => res);
    }

    // Master data add, edit and delete
    addMasterDataOrganization(data) {
        return this.http.post<any>(`${this.appCore}MasterDataOrganization`, data)
            .toPromise()
            .then(res => res);
    }

    editMasterDataOrganization(data) {
        return this.http.put<any>(`${this.appCore}MasterDataOrganization`, data)
            .toPromise()
            .then(res => res);
    }

    deleteMasterDataOrganization(id) {
        return this.http.delete<any>(`${this.appCore}MasterDataOrganization/${id}`)
            .toPromise()
            .then(res => res);
    }

    addAccountType(c) {
        return this.http.post<any>(environment.coreUrl + 'Type', c)
            .toPromise()
            .then(res => res);
    }

    EditAccountType(c) {
        return this.http.put<any>(environment.coreUrl + 'Type', c)
            .toPromise()
            .then(res => res);
    }

    deleteAccountType(id) {
        return this.http.delete<any>(environment.coreUrl + 'Type/' + id)
            .toPromise()
            .then(res => res);
    }

    // Account Sources

    addAccountSource(c) {
        return this.http.post<any>(environment.apiUrl + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    EditAccountSource(c) {
        return this.http.put<any>(environment.apiUrl + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    deleteAccountSource(id) {
        return this.http.delete<any>(environment.apiUrl + 'Source/' + id)
            .toPromise()
            .then(res => res);
    }
    addTimezone(c) {
        return this.http.post<any>(`${this.appCore}TimeZone`, c)
            .toPromise()
            .then(res => res);
    }
    EditTimezone(c) {
        return this.http.put<any>(`${this.appCore}TimeZone`, c)
            .toPromise()
            .then(res => res);
    }
    deleteTimezone(id) {
        return this.http.delete<any>(`${this.appCore}TimeZone/` + id)
            .toPromise()
            .then(res => res);
    }
    // addCurrency(c) {
    //     return this.http.post<any>(`${this.appCore}CurrencyUnit`, c)
    //         .toPromise()
    //         .then(res => res);
    // }
    // EditCurrency(c) {
    //     return this.http.put<any>(`${this.appCore}CurrencyUnit`, c)
    //         .toPromise()
    //         .then(res => res);
    // }
    // deleteCurrency(id) {
    //     return this.http.delete<any>(`${this.appCore}CurrencyUnit/` + id)
    //         .toPromise()
    //         .then(res => res);
    // }
    addOwnership(c) {
        return this.http.post<any>(this.appCore + 'Ownership', c)
            .toPromise()
            .then(res => res);
    }
    EditOwnership(c) {
        return this.http.put<any>(this.appCore + 'Ownership', c)
            .toPromise()
            .then(res => res);
    }
    deleteOwnership(id) {
        return this.http.delete<any>(this.appCore + 'Ownership/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllOwnerships() {
        return this.http.get<any>(this.appCore + 'Ownership')
            .toPromise()
            .then(res => res);
    }

    //lead
    getAllLeadStages(companyID: number) {
        return this.http.get<any>(environment.apiUrlLead + 'LeadAPI/LeadStage', {
            params: new HttpParams().append("organizationId", companyID.toString())
        })
            .toPromise()
            .then(res => res);
    }

    saveAddLeadStage(stage) {
        return this.http.post<any>(environment.apiUrlLead + 'LeadAPI/LeadStage', stage)
            .toPromise()
            .then(res => res);
    }

    saveEditLeadStage(stage) {
        return this.http.put<any>(environment.apiUrlLead + 'LeadAPI/LeadStage', stage)
            .toPromise()
            .then(res => res);
    }

    deleteLeadStage(id) {
        return this.http.delete<any>(environment.apiUrlLead + 'LeadAPI/LeadStage/' + id)
            .toPromise()
            .then(res => res);
    }

    addLeadSource(c) {
        return this.http.post<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadSource(c) {
        return this.http.put<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadSource(id) {
        return this.http.delete<any>(this.appCore + 'Source/' + id)
            .toPromise()
            .then(res => res);
    }

    addIndustry(c) {
        return this.http.post<any>(this.appCore + 'Industry', c)
            .toPromise()
            .then(res => res);
    }
    EditIndustry(c) {
        return this.http.put<any>(this.appCore + 'Industry', c)
            .toPromise()
            .then(res => res);
    }
    deleteIndustry(id) {
        return this.http.delete<any>(this.appCore + 'Industry/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllIndustries() {
        return this.http.get<any>(this.appCore + 'Industry')
            .toPromise()
            .then(res => res);
    }

    addRevenue(c) {
        return this.http.post<any>(this.appCore + 'AnnualRevenue', c)
            .toPromise()
            .then(res => res);
    }
    EditRevenue(c) {
        return this.http.put<any>(this.appCore + 'AnnualRevenue', c)
            .toPromise()
            .then(res => res);
    }
    deleteRevenue(id) {
        return this.http.delete<any>(this.appCore + 'AnnualRevenue/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllRevenue() {
        return this.http.get<any>(this.appCore + 'AnnualRevenue')
            .toPromise()
            .then(res => res);
    }

    addEmployeesNo(c) {
        return this.http.post<any>(this.appCore + 'EmployeeCount', c)
            .toPromise()
            .then(res => res);
    }
    EditEmployeesNo(c) {
        return this.http.put<any>(this.appCore + 'EmployeeCount', c)
            .toPromise()
            .then(res => res);
    }
    deleteEmployeesNo(id) {
        return this.http.delete<any>(this.appCore + 'EmployeeCount/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllEmployeesCount() {
        return this.http.get<any>(this.appCore + 'EmployeeCount')
            .toPromise()
            .then(res => res);
    }

    addLeadStatus(c) {
        return this.http.post<any>(this.appCore + 'Status', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadStatus(c) {
        return this.http.put<any>(this.appCore + 'Status', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadStatus(id) {
        return this.http.delete<any>(this.appCore + 'Status/' + id)
            .toPromise()
            .then(res => res);
    }

    addLeadType(c) {
        return this.http.post<any>(this.appCore + 'Type', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadType(c) {
        return this.http.put<any>(this.appCore + 'Type', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadType(id) {
        return this.http.delete<any>(this.appCore + 'Type/' + id)
            .toPromise()
            .then(res => res);
    }
    getAllLeadEmails() {
        return this.http.get<any>(this.localAppUrl + 'leadEmail')
            .toPromise()
            .then(res => res);
    }
    addLeadEmail(c) {
        return this.http.post<any>(this.localAppUrl + 'leadEmail', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadEmail(c) {
        return this.http.put<any>(this.localAppUrl + 'leadEmail', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadEmail(id) {
        return this.http.delete<any>(this.localAppUrl + 'leadEmail/' + id)
            .toPromise()
            .then(res => res);
    }
    getAllLeadPhones() {
        return this.http.get<any>(this.localAppUrl + 'leadPhone')
            .toPromise()
            .then(res => res);
    }
    addLeadPhone(c) {
        return this.http.post<any>(this.localAppUrl + 'leadPhone', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadPhone(c) {
        return this.http.put<any>(this.localAppUrl + 'leadPhone', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadPhone(id) {
        return this.http.delete<any>(this.localAppUrl + 'leadPhone/' + id)
            .toPromise()
            .then(res => res);
    }
    getAllLeadSocials() {
        return this.http.get<any>(this.localAppUrl + 'leadSocial')
            .toPromise()
            .then(res => res);
    }
    addLeadSocial(c) {
        return this.http.post<any>(this.localAppUrl + 'leadSocial', c)
            .toPromise()
            .then(res => res);
    }
    EditLeadSocial(c) {
        return this.http.put<any>(this.localAppUrl + 'leadSocial', c)
            .toPromise()
            .then(res => res);
    }
    deleteLeadSocial(id) {
        return this.http.delete<any>(this.localAppUrl + 'leadSocial/' + id)
            .toPromise()
            .then(res => res);
    }
    updateLeadTemplate(c) {
        return this.http.put<any>(this.localAppUrl + 'LeadTemplates/' + c.id, c)
            .toPromise()
            .then(res => res);
    }

    // case
    // as discussed with ankush group id is const and its 1 for case stages
    getCaseCategories() {
        return this.http.get<any>(`${environment.appUrl}Category?groupId=${CategoryGroupIds.CaseCategoryTicketAPI}`);
    }

    addCaseCategory(data) {
        return this.http.post<any>(`${environment.appUrl}Category`, data);
    }

    updateCaseCategory(data) {
        return this.http.put<any>(`${environment.appUrl}Category`, data);
    }

    deleteCaseCategory(id) {
        return this.http.delete<any>(`${environment.appUrl}Category/${id}`);
    }

    // as discussed with ankush group id is const and its 5 for case stages
    getAllCasesStages(companyID: number) {
        return this.http.get<any>(`${environment.appUrl}Stages?groupId=${TypeGroupIds.StageGroupIDTicketAPI}`);
    }

    addCasesStage(data) {
        return this.http.post<any>(`${environment.appUrl}Stages`, data);
    }

    updateCasesStage(data) {
        return this.http.put<any>(`${environment.appUrl}Stages`, data);
    }

    deleteCaseStage(id) {
        return this.http.delete<any>(`${environment.appUrl}Stages/${id}`);

    }
    getallCaseChannels() {
        ////console.log("Url", this.localAppUrl + 'CaseChannels');
        return this.http.get<any>(this.localAppUrl + 'CaseChannels')
            .toPromise()
            .then(res => res);
    }

    getCaseChannelById(id) {
        let url = this.localAppUrl + 'CaseChannels/' + id;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }
    // getCaseChannelById(id) {
    //     let url = this.configUrl + 'Configuration/' + id;
    //     return this.http.get<any>(url).toPromise().then(res => res);;
    // }
    updateCaseChannel(pipe) {
        return this.http.put(this.localAppUrl + 'CaseChannels/' + pipe.id, pipe, { headers: this.headers })
            .toPromise()
            .then(() => pipe);
    }
    deleteCaseChannel(id) {
        return this.http.delete<any>(this.localAppUrl + 'CaseChannels/' + id)
            .toPromise()
            .then(res => res);
    }
    getallCaseTemplates() {
        return this.http.get<any>(this.localAppUrl + 'CaseTemplates')
            .toPromise()
            .then(res => res);
    }
    getCaseTemplateById(id) {
        let url = this.localAppUrl + 'CaseTemplates/' + id;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }
    addCaseTemplate(c) {
        return this.http.post<any>(this.localAppUrl + 'CaseTemplates', c)
            .toPromise()
            .then(res => res);
    }
    updateCaseTemplate(c) {
        return this.http.put<any>(this.localAppUrl + 'CaseTemplates/' + c.id, c)
            .toPromise()
            .then(res => res);
    }
    deleteCaseTemplate(id) {
        return this.http.delete<any>(this.localAppUrl + 'CaseTemplates/' + id)
            .toPromise()
            .then(res => res);
    }
    addCaseSource(c) {
        return this.http.post<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    EditCaseSource(c) {
        return this.http.put<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    deleteCaseSource(id) {
        return this.http.delete<any>(this.appCore + 'Source/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllCategories() {
        return this.http.get<any>(this.appCore + 'Category')
            .toPromise()
            .then(res => res);
    }
    getAllCustomFieldTypes(id) {
        return this.http.get<any>(this.configUrl + "Configuration/FormControls?objectId=" + id)
            .toPromise()
            .then(res => res);
    }
    getCustomRulesFilter(objId) {
        return this.http.get<any>(this.configUrl + `Configuration/CustomAttributes?objectId=${objId}`)
            .toPromise()
            .then(res => res);

        //    https://devui01.liono360.com/MiddlewareAPI/LionO360ApplicationConfigurationAPI/LionO360/2.0/API/Configuration/CustomAttributes?objectId=2
    }
    getLevels() {
        return this.http.get<any>(this.configUrl + "Level")
    }

    getAllLevels() {
        return this.http.get<any>(this.configUrl + 'Level')
            .toPromise()
            .then(res => res);
    }

    getFieldsForMoudules(id) {
        return this.http.get<any>(this.configUrl + 'LionO360_ObjectFieldDisplay?objectId=' + id + '&categoryId=17')
            .toPromise()
            .then(res => res);
    }

    saveNotificationConfiguration(req) {
        return this.http.post<any>(this.configUrl + 'Configuration/Notification', req)
            .toPromise()
            .then(res => res);
    }

    deleteNotificationConfiguration(req) {
        return this.http.delete<any>(this.configUrl + 'Configuration/' + req)
            .toPromise()
            .then(res => res);
    }

    editNotificationConfiguration(req) {
        return this.http.put<any>(this.configUrl + 'Configuration', req)
            .toPromise()
            .then(res => res);
    }

    getNotificationConfiguration() {
        return this.http.get<any>(this.configUrl + 'Configuration')
            .toPromise()
            .then(res => res);
    }

    getFieldsValueOptions(url) {
        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }
    getFieldsValueOptionsState(url, cid) {
        return this.http.get<any>(url + '/?countryId=' + cid)
            .toPromise()
            .then(res => res);
    }
    getFieldsValueOptionsCity(url, sid) {
        return this.http.get<any>(url + '/?stateIds=' + sid)
            .toPromise()
            .then(res => res);
    }

    getallTypes() {
        return this.http.get<any>(`${this.appCore}Type?groupId=${TypeGroupIds.AllTypeCoreAPI}`)
            .toPromise()
            .then(res => res);
    }
    addCategory(c) {
        return this.http.post<any>(this.appCore + 'Category', c)
            .toPromise()
            .then(res => res);
    }
    EditCategory(c) {
        return this.http.put<any>(this.appCore + 'Category', c)
            .toPromise()
            .then(res => res);
    }
    deleteCategory(id) {
        return this.http.delete<any>(this.appCore + 'Category/' + id)
            .toPromise()
            .then(res => res);
    }
    addPriority(c) {
        return this.http.post<any>(this.localAppUrl + 'Priority', c)
            .toPromise()
            .then(res => res);
    }
    EditPriority(c) {
        return this.http.put<any>(this.localAppUrl + 'Priority', c)
            .toPromise()
            .then(res => res);
    }
    deletePriority(id) {
        return this.http.delete<any>(this.localAppUrl + 'Priority/' + id)
            .toPromise()
            .then(res => res);
    }


    //contacts
    getAllContactTypes() {
        return this.http.get<any>(`${this.appCore}Type?groupId=${TypeGroupIds.ContactType}`);
    }

    addContactType(data) {
        return this.http.post<any>(`${this.appCore}Type`, data).toPromise().then(res => res);
    }
    EditContactType(data) {
        return this.http.put<any>(`${this.appCore}Type`, data).toPromise().then(res => res);;
    }

    deleteContactType(id) {
        return this.http.delete<any>(`${this.appCore}Type/${id}`).toPromise().then(res => res);;
    }

    getContactStages() {
        return this.http.get<any>(this.contactURL + 'ContactAssociationType');
    }
    updateContactStage(data) {
        return this.http.put<any>(this.contactURL + 'ContactAssociationType', data);
    }
    addGender(c) {
        return this.http.post<any>(this.appCore + 'Gender', c)
            .toPromise()
            .then(res => res);
    }
    EditGender(c) {
        return this.http.put<any>(this.appCore + 'Gender', c)
            .toPromise()
            .then(res => res);
    }
    deleteGender(id) {
        return this.http.delete<any>(this.appCore + 'Gender/' + id)
            .toPromise()
            .then(res => res);
    }
    addLanguage(c) {
        return this.http.post<any>(this.appCore + 'Language', c)
            .toPromise()
            .then(res => res);
    }
    EditLanguage(c) {
        return this.http.put<any>(this.appCore + 'Language', c)
            .toPromise()
            .then(res => res);
    }
    deleteLanguage(id) {
        return this.http.delete<any>(this.appCore + 'Language/' + id)
            .toPromise()
            .then(res => res);
    }
    addRelationshipStatus(c) {
        return this.http.post<any>(this.appCore + 'RelationshipStatus', c)
            .toPromise()
            .then(res => res);
    }
    EditRelationshipStatus(c) {
        return this.http.put<any>(this.appCore + 'RelationshipStatus', c)
            .toPromise()
            .then(res => res);
    }
    deleteRelationshipStatus(id) {
        return this.http.delete<any>(this.appCore + 'RelationshipStatus/' + id)
            .toPromise()
            .then(res => res);
    }
    addMaritalStatus(c) {
        return this.http.post<any>(this.appCore + 'MaritalStatus', c)
            .toPromise()
            .then(res => res);
    }
    EditMaritalStatus(c) {
        return this.http.put<any>(this.appCore + 'MaritalStatus', c)
            .toPromise()
            .then(res => res);
    }
    deleteMaritalStatus(id) {
        return this.http.delete<any>(this.appCore + 'MaritalStatus/' + id)
            .toPromise()
            .then(res => res);
    }
    addContactSource(c) {
        return this.http.post<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    EditContactSource(c) {
        return this.http.put<any>(this.appCore + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    deleteContactSource(id) {
        return this.http.delete<any>(this.appCore + 'Source/' + id)
            .toPromise()
            .then(res => res);
    }
    addAnnualIncome(c) {
        return this.http.post<any>(this.appCore + 'AnnualIncome', c)
            .toPromise()
            .then(res => res);
    }
    EditAnnualIncome(c) {
        return this.http.put<any>(this.appCore + 'AnnualIncome', c)
            .toPromise()
            .then(res => res);
    }
    deleteAnnualIncome(id) {
        return this.http.delete<any>(this.appCore + 'AnnualIncome/' + id)
            .toPromise()
            .then(res => res);
    }
    addDegree(c) {
        return this.http.post<any>(this.appCore + 'Degree', c)
            .toPromise()
            .then(res => res);
    }
    EditDegree(c) {
        return this.http.put<any>(this.appCore + 'Degree', c)
            .toPromise()
            .then(res => res);
    }
    deleteDegree(id) {
        return this.http.delete<any>(this.appCore + 'Degree/' + id)
            .toPromise()
            .then(res => res);
    }
    addStudyField(c) {
        return this.http.post<any>(this.appCore + 'FieldOfStudy', c)
            .toPromise()
            .then(res => res);
    }
    EditStudyField(c) {
        return this.http.put<any>(this.appCore + 'FieldOfStudy', c)
            .toPromise()
            .then(res => res);
    }
    deleteStudyField(id) {
        return this.http.delete<any>(this.appCore + 'FieldOfStudy/' + id)
            .toPromise()
            .then(res => res);
    }
    addEmailType(c) {
        return this.http.post<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType', c)
            .toPromise()
            .then(res => res);
    }
    EditEmailType(c) {
        return this.http.put<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType', c)
            .toPromise()
            .then(res => res);
    }
    deleteEmailType(id) {
        return this.http.delete<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType/' + id)
            .toPromise()
            .then(res => res);
    }
    addPhoneType(c) {
        return this.http.post<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType', c)
            .toPromise()
            .then(res => res);
    }
    EditPhoneType(c) {
        return this.http.put<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType', c)
            .toPromise()
            .then(res => res);
    }
    deletePhoneType(id) {
        return this.http.delete<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType/' + id)
            .toPromise()
            .then(res => res);
    }
    addSocialType(c) {
        return this.http.post<any>(environment.contactAPI + '/LionO360/2.0/API/SocialProfile/SocialProfileType', c)
            .toPromise()
            .then(res => res);
    }
    EditSocialType(c) {
        return this.http.put<any>(environment.contactAPI + '/LionO360/2.0/API/SocialProfile/SocialProfileType', c)
            .toPromise()
            .then(res => res);
    }
    deleteSocialType(id) {
        return this.http.delete<any>(environment.contactAPI + '/LionO360/2.0/API/SocialProfile/SocialProfileType/' + id)
            .toPromise()
            .then(res => res);
    }

    //opportunity
    getAllInventoryPipes() {
        return this.http.get<any>(this.localAppUrl + 'inventoryPipelines')
            .toPromise()
            .then(res => res);
    }
    addInventoryPipe(c) {
        return this.http.post<any>(this.localAppUrl + 'inventoryPipelines', c)
            .toPromise()
            .then(res => res);
    }
    getInventoryPipeById(id) {
        let url = this.localAppUrl + 'inventoryPipelines/' + id;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }
    updateOppPipe(pipe) {
        return this.http.put(this.localAppUrl + 'inventoryPipelines/' + pipe.id, pipe, { headers: this.headers })
            .toPromise()
            .then(() => pipe);
    }

    getAllInventoryStages() {
        return this.http.get<any>(this.localAppUrl + 'inventoryStages')
            .toPromise()
            .then(res => res);
    }
    addOppPipeStage(c) {
        return this.http.post<any>(this.localAppUrl + 'inventoryStages', c)
            .toPromise()
            .then(res => res);
    }
    getInventoryStageById(id) {
        let url = this.localAppUrl + 'inventoryStages/' + id;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }
    updateInventoryStage(c) {
        return this.http.put<any>(this.localAppUrl + 'inventoryStages/' + c.id, c)
            .toPromise()
            .then(res => res);
    }
    deleteInventoryStage(id) {
        return this.http.delete<any>(this.localAppUrl + 'inventoryStages/' + id)
            .toPromise()
            .then(res => res);
    }
    addOppSource(c) {
        return this.http.post<any>(this.configUrl + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    getAllOppSource(organizationId) {
        return this.http.get<any>(this.configUrl + 'Source', {
            params: new HttpParams().append("organizationId", organizationId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllOppRatings() {
        return this.http.get<any>(this.configUrl + 'Rating')
            .toPromise()
            .then(res => res);
    }

    EditOppSource(c) {
        return this.http.put<any>(this.configUrl + 'Source', c)
            .toPromise()
            .then(res => res);
    }
    deleteOppSource(id) {
        return this.http.delete<any>(this.appCore + 'Source/' + id)
            .toPromise()
            .then(res => res);
    }
    addRating(c) {
        return this.http.post<any>(this.appCore + 'Rating', c)
            .toPromise()
            .then(res => res);
    }
    EditRating(c) {
        return this.http.put<any>(this.appCore + 'Rating', c)
            .toPromise()
            .then(res => res);
    }
    deleteRating(id) {
        return this.http.delete<any>(this.appCore + 'Rating/' + id)
            .toPromise()
            .then(res => res);
    }

    //opportunity
    getallQuestionnaireChannels(companyID) {
        return this.http.get<any>(this.questionnaireURL + "QuestionnaireChannel?OrganizationId=" + companyID)
            .toPromise()
            .then(res => res);
    }

    getQuestionnaireChannelById(id) {
        let url = this.questionnaireURL + "QuestionnaireChannel/" + id;
        return this.http.get<any>(url).toPromise();
    }

    getallQuestionnaireTemplates(companyID) {
        return this.http.get<any>(this.questionnaireURL + "Questionnaire?OrganizationId=" + companyID)
            .toPromise()
            .then(res => res);
    }

    getModulesForQuestionnaire() {
        return this.http.get<any>(this.configUrl + `LionO360_Object`)
    }

    addQuestionnaireChannel(c) {
        return this.http.post<any>(this.questionnaireURL + "QuestionnaireChannel", c)
            .toPromise()
            .then(res => res);
    }
    EditQuestionnaireChannel(c) {
        return this.http.put<any>(this.questionnaireURL + "QuestionnaireChannel", c)
            .toPromise()
            .then(res => res);
    }
    deleteQuestionnaireChannel(id) {
        return this.http.delete<any>(this.questionnaireURL + "QuestionnaireChannel/" + id)
            .toPromise()
            .then(res => res);
    }
    deleteQuestionnaireTemplate(id) {
        return this.http.delete<any>(this.questionnaireURL + "Questionnaire/" + id)
            .toPromise()
            .then(res => res);
    }
    getallQuestionnaireGroups(groupID) {
        return this.http.get<any>(this.appOrgUrl + 'Type?groupId=' + groupID)
            .toPromise()
            .then(res => res);
    }
    getallQuestionnaireGroup(groupID) {
        return this.http.get<any>(this.questionnaireURL + 'Type?groupId=' + groupID)
            .toPromise()
            .then(res => res);
    }

    getAllQuestionnaireGroups(groupID) {
        return this.http.get<any>(this.questionnaireURL + 'Group')
            .toPromise()
            .then(res => res);
    }


    getAllQuestionnaireTypes(groupId) {
        return this.http.get<any>(this.questionnaireURL + `Type?groupId=${groupId}`)
            .toPromise()
            .then(res => res);
    }

    getQustionnaireGroupId() {
        return this.http.get<any>(this.appOrgUrl + 'Group')
            .toPromise()
            .then(res => res);
    }

    getQustionnaireGroupIds() {
        return this.http.get<any>(this.questionnaireURL + 'Group')
            .toPromise()
            .then(res => res);
    }

    getAllTypes() {
        return this.http.get<any>(`${environment.appOrgUrl}Type`)
            .toPromise()
            .then(res => res);
    }

    EditQuestionnaireGroup(c) {
        return this.http.put<any>(this.questionnaireURL + 'Type', c)
            .toPromise()
            .then(res => res);
    }
    getallQuestionnaireQuestions(companyID, isActiveInactive:boolean) {
        return this.http.get<any>(this.questionnaireURL + "Question?OrganizationId=" + companyID + "&isActive=" + isActiveInactive)
            .toPromise()
            .then(res => res);
    }
    EditQuestionnaireTemplate(c) {
        return this.http.put<any>(this.questionnaireURL + "Questionnaire", c)
            .toPromise()
            .then(res => res);
    }
    addQuestion(c) {
        return this.http.post<any>(this.questionnaireURL + "Question", c)
            .toPromise()
            .then(res => res);
    }
    EditQuestion(c) {
        return this.http.put<any>(this.questionnaireURL + "Question", c)
            .toPromise()
            .then(res => res);
    }
    deleteQuestion(id) {
        return this.http.delete<any>(this.questionnaireURL + "Question/" + id)
            .toPromise()
            .then(res => res);
    }
    getallUserGroups() {
        return this.http.get<any>(environment.appOrgUrl + "UserGroup/")
            .toPromise()
            .then(res => res);
    }
    getallObjectTypes() {
        return this.http.get<any>(this.configUrl + "LionO360_Object/")
            .toPromise()
            .then(res => res);
    }
    getallAnswerTypes() {
        return this.http.get<any>(this.questionnaireURL + "FormControl")
            .toPromise()
            .then(res => res);
    }

    getRuleFilters(objId, typeId) {
        ////console.log(objId, typeId)
        return this.http.get<any>(this.configUrl + `Configuration/ByObjectTypeCategory?organizationId=0&objectId=${objId}&typeId=${typeId}`)
            .toPromise()
            .then(res => res);
    }


    // users
    getOrgUsers(organizationId, IncludeDeleted = false) {
        return this.http.get<any>(`${this.appOrgUrl}User?OrganizationId=${organizationId}&IncludeDeleted=${IncludeDeleted}&inActive=false&both=true`)
    }

    //new userList API
    getOrgUsersList() {
        return this.http.get<any>(`${this.appOrgUrl}User/UserList`);
    }


    getRoleWiseUsers() {
        return this.http.get<any>(`${this.appOrgUrl}User/DownLineRoleWiseUser`)
    }

    getOrgUserById(userId) {
        return this.http.get<any>(`${this.appOrgUrl}User/${userId}`);
    }

    getOrgRoles(organizationId) {
        return this.http.get<any>(`${this.appOrgUrl}Organization/Role?OrganizationId=${organizationId}`)
    }

    getJobTypes() {
        return this.http.get<any>( `${environment.appOrgUrl}JobType`);
    }

    getUserWorkingLocation(){
        return this.http.get<any>( `${environment.appOrgUrl}Organization/OrgAddress`);
    }

    getMaritialStatus() {
        return this.http.get<any>(`${this.configUrl}MaritalStatus`)
    }

    getFieldOfStudies() {
        return this.http.get<any>(`${this.configUrl}FieldOfStudy`)
    }

    getAllCountries() {
        return this.http.get<any>(`${this.configUrl}Country`)
    }

    getAllBranches(organizationId) {
        return this.http.get<any>(`${this.appOrgUrl}Organization/Address?OrganizationId=${organizationId}`);
    }

    deleteUser(userId) {
        return this.http.delete<any>(`${this.appOrgUrl}User/${userId}`);
    }

    deleteRole(roleId) {
        return this.http.delete<any>(`${this.appOrgUrl}Organization/Role/${roleId}`);
    }

    addUser(data) {
        return this.http.post<any>(`${this.appOrgUrl}User`, data);
    }

    updateUser(data) {
        return this.http.put<any>(`${this.appOrgUrl}User`, data);
    }
    updateRole(data) {
        return this.http.put<any>(`${this.appOrgUrl}Organization/Role`, data);
    }

    addRole(data) {
        return this.http.post<any>(`${this.appOrgUrl}Organization/Role`, data);
    }

    getOrgUserGroups(organizationId) {
        return this.http.get<any>(`${this.appOrgUrl}UserGroup?OrganizationId=${organizationId}`)
    }

    deleteUserGroup(userGroupId) {
        return this.http.delete<any>(`${this.appOrgUrl}UserGroup/${userGroupId}`);
    }

    saveAddUserGroup(tempUserGroup) {
        return this.http.post<any>(`${this.appOrgUrl}UserGroup`, tempUserGroup)
    }

    updateAddUserGroup(tempUserGroup) {
        return this.http.put<any>(`${this.appOrgUrl}UserGroup`, tempUserGroup)
    }

    addDepartment(data) {
        return this.http.post<any>(`${this.appOrgUrl}Department`, data);
    }

    editDepartment(data) {
        return this.http.put<any>(`${this.appOrgUrl}Department`, data);
    }

    deleteDepartment(id) {
        return this.http.delete<any>(`${this.appOrgUrl}Department/${id}`)
    }

    getRolePermissions(roleId) {
        return this.http.get<any>(`${this.appOrgUrl}RolePermission?RoleId=${roleId}`);
    }

    assignRolePermissions(updatedPermissionData) {
        return this.http.post<any>(`${this.appOrgUrl}RolePermission/MultipleRolePermission`, updatedPermissionData);
    }

    getUserPermissions(userId) {
        return this.http.get<any>(`${this.appOrgUrl}UserPermission?userId=${userId}`);
    }
    getUserPermissionsReport(userId) {
        // return this.http.get<any>(`${this.appOrgUrl}UserPermission/GetAllUserPermissionReport?userId=${userId}`).toPromise()
        //     .then(res => res);
        return this.http.get<any>(`${this.appOrgUrl}UserProfilePermission/AllReportPermission/${userId}`).toPromise()
            .then(res => res);
    }

    getRolePermissionsReport(roleId) {
        return this.http.get<any>(`${this.appOrgUrl}RolePermission/ReportPermission?RoleId=${roleId}`);
    }

    assignUserPermissions(updatedPermissionData) {
        return this.http.post<any>(`${this.appOrgUrl}UserPermission/MultipleUserPermission`, updatedPermissionData);
    }

    getUserOrgChartData(userId) {
        return this.http.get<any>(`${this.appOrgUrl}User/${userId}/UserFlow`);
    }

    getAllUserOrgChartData(userId) {
        return this.http.get<any>(`${this.appOrgUrl}User/${userId}/AllWorkFlowUserTree`);
    }

    //inventory
    addBrandList(c) {
        return this.http.post<any>(`${environment.coreUrl}Brand`, c)
            .toPromise()
            .then(res => res);
    }
    EditBrandList(c) {
        return this.http.put<any>(`${environment.coreUrl}Brand`, c)
            .toPromise()
            .then(res => res);
    }
    deleteBrandList(id) {
        return this.http.delete<any>(`${environment.coreUrl}Brand` + '/' + id)
            .toPromise()
            .then(res => res);
    }
    getInventoryGroupList() {
        return this.http.get<any>(`${environment.coreUrl}Group`);
    }

    getInventoryCategoryList(groupId) {
        return this.http.get<any>(`${environment.inventoryURl}Category/CategoryHierarchy?groupId=${groupId}`);
    }

    addInventoryCategory(obj) {

        return this.http.post<any>(`${environment.inventoryURl}Category`, obj)
            .toPromise()
            .then(res => res);


    }

    updateInventoryCategory(obj) {

        return this.http.put<any>(`${environment.inventoryURl}Category`, obj)
            .toPromise()
            .then(res => res);


    }

    //finance
    getAllCharts() {
        return this.http.get<any>(this.localAppUrl + 'allCharts')
            .toPromise()
            .then(res => res);
    }
    addChart(c) {
        return this.http.post<any>(this.localAppUrl + 'allCharts', c)
            .toPromise()
            .then(res => res);
    }
    EditChart(c) {
        return this.http.put<any>(this.localAppUrl + 'allCharts', c)
            .toPromise()
            .then(res => res);
    }
    deleteChart(id) {
        return this.http.delete<any>(this.localAppUrl + 'allCharts/' + id)
            .toPromise()
            .then(res => res);
    }

    getAllClasses() {
        return this.http.get<any>(this.localAppUrl + 'allClasses')
            .toPromise()
            .then(res => res);
    }
    addClass(c) {
        return this.http.post<any>(this.localAppUrl + 'allClasses', c)
            .toPromise()
            .then(res => res);
    }
    EditClass(c) {
        return this.http.put<any>(this.localAppUrl + 'allClasses', c)
            .toPromise()
            .then(res => res);
    }
    deleteClass(id) {
        return this.http.delete<any>(`${environment.inventoryURl}Category/${id}`)
            .toPromise()
            .then(res => res);
    }
    getAllQtys() {
        return this.http.get<any>(this.localAppUrl + 'allQty')
            .toPromise()
            .then(res => res);
    }
    addQty(c) {
        return this.http.post<any>(this.localAppUrl + 'allQty', c)
            .toPromise()
            .then(res => res);
    }
    EditQty(c) {
        return this.http.put<any>(this.localAppUrl + 'allQty', c)
            .toPromise()
            .then(res => res);
    }
    deleteQty(id) {
        return this.http.delete<any>(this.localAppUrl + 'allQty/' + id)
            .toPromise()
            .then(res => res);
    }

    checkProductAvailability(id) {
        return this.http.get<any>(`${environment.inventoryURl}Category/CheckCategoryHasProduct?id=${id}`)
    }

    getStatesByCountryId(id) {
        return this.http.get<any>(this.apiUrl + 'State/?countryId=' + id)
            .toPromise()
            .then(res => res);
    }

    getCitiesByStateId(id) {
        return this.http.get<any>(this.apiUrl + 'City/?stateId=' + id)
            .toPromise()
            .then(res => res);
    }

    getAllCountriesStatesCities() {
        return this.http.get<any>(this.apiUrl + 'Country/State/City');
    }

    getOrganizationById(id) {
        return this.http.get<any>(this.appOrgUrl + 'Organization/' + id);
    }

    getDecimalAndQtyConfigByOrganizationId(id) {
        return this.http.get<any>(this.appOrgUrl + 'Org/' + id);
    }

    //new APi
    getOrganizationData(){
            return this.http.get<any>(this.appOrgUrl + 'Org/Organization');
    }

    updateOrganization(data,isSetting?) {
    let params = new HttpParams();
    params = (!isSetting ? params : params.append('isSetting', 'true'))
    return this.http.put<any>(this.appOrgUrl + 'Organization', data, { params });
    }

    updateOrg(data:any) {

        return this.http.put<any>(this.appOrgUrl + 'Org', data);
    }

    getOrganizationBranchesByOrgId(id) {
        return this.http.get<any>(this.appOrgUrl + 'Organization/Address?OrganizationId=' + id);
    }

    //new api for getOrganizationBranchesByOrgId
    getOrganizationBranchesAddress() {
        return this.http.get<any>(`${environment.appOrgUrl}OrganizationAddress`);
    }

    addBranch(data) {
        return this.http.post<any>(this.appOrgUrl + 'Organization/Address/', data);
    }

    updateBranch(data) {
        return this.http.put<any>(this.appOrgUrl + 'Organization/Address', data);
    }

    deleteBranch(branchId: number) {
        return this.http.delete<any>(this.appOrgUrl + 'Organization/Address',{params: new HttpParams().append("id", `${branchId}`)});
    }

    getAllCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
            params: new HttpParams().append("stateId", `${stateId}`)
        })
            .toPromise()
            .then(res => res);
    }

    getAllStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
            params: new HttpParams().append("countryId", `${countryId}`)
        })
            .toPromise()
            .then(res => res);
    }

    loadFieldList(templateId, objectId) {
        return this.http.get<any>(`${environment.configUrl}Configuration/Field/${templateId}?objectId=${objectId}`)
    }

    getContactRoles() {
        return this.http.get<any>(`${this.contactURL}Type/JobFunctionMinified`);
    }

    getAllContactRoles() {
        return this.http.get<any>(`${this.appCore}Type?groupId=${TypeGroupIds.JobFuctionsContactAPI}`);
    }

    addContactRole(data) {
        return this.http.post<any>(`${this.appCore}Type`, data);
    }
    updateContactRole(data) {
        return this.http.put<any>(`${this.appCore}Type`, data);
    }

    deleteContactRole(id) {
        return this.http.delete<any>(`${this.appCore}Type/${id}`);
    }
    getSalutation() {
        return this.http.get<any>(`${this.contactURL}Salutation`);
    }
    addSalutation(data) {
        return this.http.post<any>(`${this.contactURL}Salutation`, data);
    }
    updateSalutation(data) {
        return this.http.put<any>(`${this.contactURL}Salutation`, data);
    }
    deleteSalutation(id) {
        return this.http.delete<any>(`${this.contactURL}Salutation/${id}`);
    }

    getConfigurationByModuleName(name) {
        return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`)

    }

    getAllVendorSMTPRegistration() {
        return this.http
            .get<any>(`${this.vendorUrl}VendorSMTPRegistration`);
    }

    searchVendorSMTPRegistration(pageNumber, pageSize, sortBy, isAscending, searchValue, searchColumn) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = params.append("PageNumber", pageNumber);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        return this.http
            .get<any>(`${this.vendorUrl}VendorSMTPRegistration?SearchValue=${searchValue}`, { params });
    }

    getVendorSMTPRegistrationById(id) {
        return this.http
            .get<any>(`${this.vendorUrl}VendorSMTPRegistration/${id}`);
    }

    deleteVendorSMTPRegistration(id) {
        return this.http
            .delete<any>(`${this.vendorUrl}VendorSMTPRegistration/${id}`);
    }

    saveVendorSMTPRegistration(data) {
        return this.http
            .post<any>(`${this.vendorUrl}VendorSMTPRegistration`, data);
    }

    updateVendorSMTPRegistration(data) {
        return this.http
            .put<any>(`${this.vendorUrl}VendorSMTPRegistration`, data);
    }

    // Address Type
    addAddressType(c) {
        return this.http.post<any>(environment.apiUrl + 'Address/AddressType', c);
    }

    updateAddressType(c) {
        return this.http.put<any>(environment.apiUrl + 'Address/AddressType', c);
    }

    deleteAddressType(id) {
        return this.http.delete<any>(environment.apiUrl + 'Address/AddressType/' + id);
    }

    // Address Class
    addAddressClass(c) {
        return this.http.post<any>(environment.apiUrl + 'Address/AddressClass', c);
    }

    updateAddressClass(c) {
        return this.http.put<any>(environment.apiUrl + 'Address/AddressClass', c);
    }

    deleteAddressClass(id) {
        return this.http.delete<any>(environment.apiUrl + 'Address/AddressClass/' + id);
    }

    // CurrencyUnit
    addCurrency(c) {
        return this.http.post<any>(environment.apiUrl + 'CurrencyUnit', c);
    }

    updateCurrency(c) {
        return this.http.put<any>(environment.apiUrl + 'CurrencyUnit', c);
    }

    deleteCurrency(id) {
        return this.http.delete<any>(environment.apiUrl + 'CurrencyUnit/' + id);
    }

    getConfigurationsByTemplateName(templateName: string) {
        return this.http.get<any>(`${this.configUrl}Configuration/ConfigurationByTemplateName?templateName=${templateName}`);
    }

    getTemplateDetails(mainobjectId: number, objectId: number, templateId: number, isParent: boolean = false) {
        return this.http.get<any>(`${this.configUrl}Configuration/TemplateDetails?mainobjectId=${mainobjectId}&objectId=${objectId}&templateId=${templateId}&isParent=${isParent}`);
    }

    getChannelStages(objectId: number, channelId: number) {
        return this.http.get<any>(`${this.configUrl}Configuration/ChannelStages?objectId=${objectId}&channelId=${channelId}`);
    }

    getSMTPVendor(){
        return this.http.get<any>(`${environment.vendorUrl}Vendor`);
    }

    sequenceNumberByModuleId(moduleId){
        return this.httpService.getAll(`${environment.configUrlV2}/ModuleSequence/Module/${moduleId}`)
    }

    generateSequenceNumberByModuleId(moduleId){
        return this.http.get(`${environment.configUrlV2}/ModuleSequence/Generate/Module/${moduleId}`,{ responseType: 'text' })
    }

    generateChildAccountSequenceNumber(parentId: number){
        return this.http.get(`${environment.configUrlV2}/ModuleSequence/Generate/AccountChildSequenceNumber/${parentId}`,{ responseType: 'text' })
    }

    getAllNotificationTemplateByModuleId(moduleId){
        return this.http.get<Template>(`${environment.notificationUrl2}NotificationTemplate?moduleId=${moduleId}&channelId=1&status=1`)
    }

    getCrmSettingFieldsList(): Observable<any>{
        return this.http.get<Template>(`${environment.configUrlV2}/ModuleSetting`)
    }

    getPhoneNumberTemplate(moduleId:any): Observable<any>{
        return this.http.get<Template>(`${environment.configUrlV2}/ModuleSetting?moduleId=${moduleId}`);
    }

    updateCrmSetting(data){
        return this.http.put<Template>(`${environment.configUrlV2}/ModuleSetting`,data);
    }

    getSavedSearchWorkFlowSettings(): Observable<any>{
        return this.http.get(`${environment.appOrgUrl}Access`)
    }

    setSavedSearchWorkFlowSettings(data:any[]): Observable<any>{
        return this.http.post<any>(`${environment.appOrgUrl}Access`, data);
    }

    fSettingAddress(data){
        return this.http.post<Template>(`${environment.configUrl}AddressChoice`,data);
    }

    getFSettingAddress(){
        return this.http.get<Template>(`${environment.configUrl}AddressChoice`);
    }

    getTimeZoneId(organizationId:any) {
        return this.http.get<any>( `${environment.appOrgUrl}User/DefualtTimeZone/${organizationId}`);
    }

    getMFAUserList(){
        return this.http.get<any>(`${environment.baseUrl}LionO360ApplicationAuthenticationAPI/LionO360/2.0/API/User`)
    }

    setUserMFA(data : any){
        return this.http.post<any>(`${environment.baseUrl}LionO360ApplicationAuthenticationAPI/LionO360/2.0/API/User/SetUserMFA`,data)
    }

    userReSetAuthen(userId : any){
        return this.httpService.put(`${environment.baseUrl}LionO360ApplicationAuthenticationAPI/LionO360/2.0/API/User/ReSetUserSetup/${userId}`)
    }

    notifyUserAdded() {
        this.userAddedSubject.next();
      }

      //Decimal Limit Org level
      getDecimalValue() {
        return this.http.get<any>(`${environment.appOrgUrl}Org/Settings`)
     }

    getDefaultTimeOutValue() {
        return this.http.get<any>(`${environment.appOrgUrl}Org/Settings`)
    }

    getNewAllContactRoles() {
        return this.http.get<any>(`${this.appCore}Type?groupId=${TypeGroupIds.contactRolesId}`);
    }

    getJournalTemplateDetails() {
        return this.http.get<any>(`${this.configUrl}Configuration/JournalTemplateDetails`);
    }
}

